import { formattedFirearm, getFormattedDate } from "@/queue/elements/value-formatters/date-formatter.mjs";
import { FFLListTransfer } from "./ffl-boa-get-transformer.mjs";
import { transferMacrostatus, transferMicrostatus } from "@/utils/constants";
import { TransferTypeInTransferList, keyType } from "@/queue/types";

export interface TransferReport{
    "Transfer Type": string
    Status?: string,
    "Sub-Status"?: string,
    "Transfer Initiated"?: string,
    "Archive Date"?: string
    Age?: string,
    "Store Name"?: string
    "order ID"?: string,
    "Buyer Name"?: string,
    "License No."?: string
    "Receiving FFL"?: string
    "Seller FFL"?: string
    "Firearm Type"?: string
    "Agent"?: string
    "Transfer Code"?: string;
    "Transfer Completed"? : string
    "Inbound Transfer Complete"?: string
    "Ready for Outbound Processing"?: string
    "Source"?: string

}

export default class TransferReportBuilder {
    static buildTransfer(i: FFLListTransfer): TransferReport {
        const result: TransferReport = {
            "Transfer Type": TransferTypeInTransferList[i.transferType as keyType<typeof TransferTypeInTransferList>],
            Status: transferMacrostatus[i.derivedStatus as keyType<typeof transferMacrostatus>],
            "Sub-Status": transferMicrostatus[i.microStatus as keyType<typeof transferMicrostatus>],
            "Transfer Initiated": getFormattedDate(i.createdAt as Date),
            "Inbound Transfer Complete": i?.inboundTransferCompletionTime ? getFormattedDate(i?.inboundTransferCompletionTime as Date) : '',
            "Ready for Outbound Processing": i?.outboundTransferCompletionTime ? getFormattedDate(i?.outboundTransferCompletionTime as Date) : '',
            "Transfer Completed": getFormattedDate(i.transferCompletionTime as Date),
            "Archive Date": getFormattedDate(i.archiveDate as Date),
            Age: i.age,
            "Store Name": i.storeName,
            "order ID": i.referenceId,
            "Buyer Name": i.buyerName,
            "Seller FFL": i.sellerName,
            "Receiving FFL": i.licensee?.name,
            "Firearm Type": formattedFirearm(i.firearm),
            Agent: i.agent,
            "Transfer Code": i.transferCode,
            "Source": i.source
        };
        return result;
    }

    static buildTransferReportList(i: FFLListTransfer): TransferReport[] {
        return i.items.map(item => TransferReportBuilder.buildTransfer(item));
    }
}